import { HomeIcon, MenuIcon, BasketIcon, AccountIcon, LanguageIcon } from '../../icons/NavIcons';
import { Badge, Bar, IconWrapper, TabItem, TabLabel } from './MobileTabBar.styles';
import type { MobileTabBarProps } from './MobileTabBar.types';

const mobileIconMap = {
  home: HomeIcon,
  menu: MenuIcon,
  basket: BasketIcon,
  account: AccountIcon,
  language: LanguageIcon,
} as const;

export function MobileTabBar({ items, navigationLabel = 'Main navigation' }: MobileTabBarProps) {
  return (
    <Bar aria-label={navigationLabel}>
      {items.map((item) => {
        const IconComponent = mobileIconMap[item.icon];
        const hasBadge = item.badge != null && item.badge > 0;
        return (
          <TabItem
            key={item.id}
            $active={item.active}
            onClick={item.onClick}
            type="button"
            aria-label={item.label}
          >
            <IconWrapper>
              {item.icon === 'basket' ? (
                <BasketIcon size={22} count={hasBadge ? item.badge : undefined} />
              ) : (
                <>
                  <IconComponent size={22} />
                  {hasBadge && <Badge>{item.badge}</Badge>}
                </>
              )}
            </IconWrapper>
            <TabLabel>{item.label}</TabLabel>
          </TabItem>
        );
      })}
    </Bar>
  );
}
